export default __webpack_public_path__ + "static/media/routing_rules.cfd852c5.svg";